import { AxiosResponse } from "axios";
import { axiosRequest } from "../api.utils";
import { API_ROOT } from "services/baseURLs.config";
import { Order } from "model/Analytics";

const getOrders = async (
  companyId: number,
  startDate: string,
  endDate: string,
): Promise<AxiosResponse<Order[]>> => {
  return await axiosRequest.auth.get<Order[]>(
    `${API_ROOT}/analytics/${companyId}/orders?startDate=${startDate}&endDate=${endDate}`,
  );
};

export const analytics = {
  getOrders
};
